<template>
  <modal v-bind="$attrs" v-on="$listeners" :title="getTitle">
    <template v-slot:body>
      <p>
        {{
          $t(
            $i18nLabelsHelper(
              $store.getters["organization/currentOrganizationType"],
              "modals.delete_from_group.message"
            ),
            {
              numberOfAccounts: numberOfSelectedUsers,
            }
          )
        }}
      </p>
      <el-checkbox
        class="elsa-checkbox"
        label="consent"
        v-if="isElsaAdmin"
        v-model.lazy="isRemoveUserFromSystem"
      >
        {{ $t("common.remove_user_from_system") }}
      </el-checkbox>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button
          class="confirm-delete"
          ref="submitEditOrganizationUserButton"
          @click.native="handleSubmitDeleteUsers"
        >
          {{ $t("organization_profile.remove_admin_modal.yes_remove") }}
        </primary-button>
        <tertiary-button @click.native="$emit('closed')">
          {{ $t("organization_profile.remove_admin_modal.no_cancel") }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import { mapGetters } from "vuex";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";

export default {
  props: {
    numberOfSelectedUsers: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
  },
  data() {
    return {
      isRemoveUserFromSystem: false,
    };
  },

  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    getTitle() {
      return this.$t(
        this.$i18nLabelsHelper(
          this.$store.getters["organization/currentOrganizationType"],
          "modals.delete_from_group.title"
        ),
        {
          numberOfAccounts: this.numberOfSelectedUsers,
        }
      );
    },
  },
  methods: {
    handleSubmitDeleteUsers() {
      this.$emit("closed");
      this.$emit("doRemoveStudentFromClass", this.isRemoveUserFromSystem);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
p {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: #eb5757;
}
.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}
.elsa-checkbox {
  display: inline-block !important;
  margin-left:auto !important;
  margin-right:auto !important;
}
</style>
